<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          class="box"
          ref="customerForm"
          :model="customer"
          label-width="80px"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('customer.serialNo')">
                  {{ customer.serialNo }}
                  <span v-if="customer.isMember == true" class="green font10">
                    {{ $t("customer.isMember") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('user.name')">{{
                  customer.name
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('customer.company')">{{
                  customer.company
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('user.phone')">{{
                  customer.phone
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('customer.email2')">{{
                  customer.email
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.type')">
                  <span v-if="customer.type != null">{{
                    $t("customerTypes." + customer.type)
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('customer.source')">{{
                  customer.source
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.owner')">{{
                  customer.ownerName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('customer.balance')">
                  <span
                    class="blue"
                    @click="
                      $router.push(
                        '/normal/oms/customers/balances/' + customer.id
                      )
                    "
                    >{{ customer.balance | currency }}</span
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.score')">
                  <span
                    class="blue"
                    @click="
                      $router.push(
                        '/normal/oms/customers/scores/' + customer.id
                      )
                    "
                    >{{ customer.score }}</span
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("customer.addressInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.country')">
                  <span v-if="customer.country != null">{{
                    $t("countries." + customer.country)
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.province')">{{
                  customer.province
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.city')">{{
                  customer.city
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('customer.zipcode')">{{
                  customer.zipcode
                }}</el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item :label="$t('tenant.address')">{{
                  customer.address
                }}</el-form-item>
              </el-col>
            </el-row>

            <vxe-table
              :data="customer.addresses"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
            >
              <vxe-table-column
                field="name"
                :title="$t('text.name')"
                min-width="80"
              />

              <vxe-table-column
                field="phone"
                :title="$t('courier.phone')"
                min-width="100"
              />

              <vxe-table-column
                field="country"
                :title="$t('tenant.country')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <span v-if="row.country != null">{{
                    $t("countries." + row.country)
                  }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="province"
                :title="$t('tenant.province')"
                min-width="80"
              />
              <vxe-table-column
                field="city"
                :title="$t('tenant.city')"
                min-width="80"
              />
              <vxe-table-column
                field="address"
                :title="$t('tenant.address')"
                min-width="100"
              />
              <vxe-table-column
                field="zipcode"
                :title="$t('customer.zipcode')"
                min-width="80"
              />
              <vxe-table-column
                v-if="Permit.canActions('customerUpdate')"
                field="action"
                :title="$t('text.action')"
                width="100"
              >
                <template v-slot="{ row, rowIndex }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="editAddress(row, rowIndex)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="deleteAddress(row)"
                    >{{ $t("text.delete") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
          <fieldset v-if="customer.remark != null" class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <raw-html :content="customer.remark"></raw-html>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="defalut"
        plain
        size="small"
        @click="$router.push('/normal/oms/customers/orders/' + customer.id)"
        >{{ $t("action.customersOrders") }}</el-button
      >
      <el-button
        type="defalut"
        plain
        size="small"
        @click="$router.push('/normal/oms/customers/balances/' + customer.id)"
        >{{ $t("action.customersBalance") }}</el-button
      >
      <el-button
        v-if="Permit.canActionsChargeEdition('customerDistributiveOwner')"
        type="warning"
        plain
        size="small"
        @click="distributiveOwner"
        >{{ $t("action.distributiveOwner") }}</el-button
      >
      <el-button
        v-if="Permit.canActionsChargeEdition('customerCreate')"
        type="primary"
        plain
        size="small"
        @click="recharge"
        >{{ $t("action.recharge") }}</el-button
      >
      <el-button
        v-if="Permit.canActionsChargeEdition('customerCreate')"
        type="success"
        plain
        size="small"
        @click="rechargeScore"
        >+ {{ $t("action.rechargeScore") }}</el-button
      >

      <el-button
        type="primary"
        plain
        size="small"
        v-if="!customer.isMember"
        @click="upgradeToMember"
        >{{ $t("action.upgradeToMember") }}</el-button
      >
      <el-button
        v-if="Permit.canActions('customerUpdate')"
        type="primary"
        plain
        size="small"
        @click="addAddress"
        >{{ $t("action.addAddress") }}</el-button
      >
    </div>
    <!-- 分配拥有人 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.distributiveOwner')"
      :close-on-click-modal="false"
      :visible.sync="distributiveOwnerDF"
      width="30%"
    >
      <el-form ref="distributiveOwnerObjForm" :model="distributiveOwnerObj">
        <el-form-item
          :prop="'ownerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.owner')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="distributiveOwnerObj.ownerId"
            filterable
            clearable
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="distributiveOwnerDoing"
          size="small"
          @click="distributiveOwnerSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="distributiveOwnerDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 充值 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.recharge')"
      :close-on-click-modal="false"
      :visible.sync="rechargeDF"
      width="30%"
    >
      <el-form ref="rechargeObjForm" :model="rechargeObj" label-width="80px">
        <el-form-item
          :label="$t('customer.rechargeAmount')"
          :prop="'balance'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('customer.rechargeAmount')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="rechargeObj.balance"
            :placeholder="$t('customer.rechargeAmount')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('payment.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="rechargeObj.payMethodId"
            filterable
            clearable
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="rechargeObj.remark"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="rechargeObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="rechargeDoing"
          size="small"
          @click="rechargeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rechargeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 充值 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.rechargeScore')"
      :close-on-click-modal="false"
      :visible.sync="rechargeScoreDF"
      width="30%"
    >
      <el-form
        ref="rechargeScoreObjForm"
        :model="rechargeScoreObj"
        label-width="80px"
      >
        <el-form-item :prop="'type'" label-width="0px" class="center">
          <el-radio-group v-model="rechargeScoreObj.type" size="mini">
            <el-radio-button label="in">{{
              $t("rechargeScoreTypes.in")
            }}</el-radio-button>
            <el-radio-button label="out">{{
              $t("rechargeScoreTypes.out")
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('product.score')"
          :prop="'score'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('product.score')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="rechargeScoreObj.score"
            :placeholder="$t('product.score')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.type')" :prop="'chargeType'">
          <el-input
            size="small"
            v-model.trim="rechargeScoreObj.chargeType"
            :placeholder="$t('text.type')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="rechargeScoreObj.remark"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="rechargeScoreDoing"
          size="small"
          @click="rechargeScoreSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rechargeScoreDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :append-to-body="true"
      :title="$t('action.upgradeToMember')"
      :close-on-click-modal="false"
      :visible.sync="upgradeToMemberDF"
      width="30%"
    >
      <el-form
        ref="upgradeToMemberObjForm"
        :model="upgradeToMemberObj"
        label-width="80px"
      >
        <el-form-item
          :label="$t('user.phone')"
          :prop="'phone'"
          :rules="[
            { required: true, validator: validatePhone, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="upgradeToMemberObj.phone" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="upgradeToMemberSubmitDoing"
          size="small"
          @click="upgradeToMemberSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="upgradeToMemberDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增地址客户 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.addAddress')"
      :close-on-click-modal="false"
      :visible.sync="addAddressDF"
      width="30%"
    >
      <el-form
        ref="addAddressObjForm"
        :model="addAddressObj"
        label-width="90px"
      >
        <el-form-item
          :label="$t('user.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addAddressObj.name" />
        </el-form-item>
        <el-form-item
          :label="$t('user.phone')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.phone')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addAddressObj.phone" />
        </el-form-item>
        <el-form-item
          :label="$t('tenant.country')"
          :prop="'country'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addAddressObj.country"
            filterable
            clearable
          >
            <el-option
              v-for="country in countries"
              :key="country"
              :label="$t('countries.' + country)"
              :value="country"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('tenant.province')" :prop="'province'">
          <el-input size="small" v-model.trim="addAddressObj.province" />
        </el-form-item>
        <el-form-item :label="$t('tenant.city')" :prop="'city'">
          <el-input size="small" v-model.trim="addAddressObj.city" />
        </el-form-item>
        <el-form-item :label="$t('tenant.address')" :prop="'address'">
          <el-input size="small" v-model.trim="addAddressObj.address" />
        </el-form-item>
        <el-form-item :label="$t('customer.zipcode')" :prop="'zipcode'">
          <el-input
            size="small"
            v-model.trim="addAddressObj.zipcode"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addAddressDoing"
          size="small"
          @click="addAddressSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addAddressDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑地址客户 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.editAddress')"
      :close-on-click-modal="false"
      :visible.sync="editAddressDF"
      width="30%"
    >
      <el-form
        ref="editAddressObjForm"
        :model="editAddressObj"
        label-width="90px"
      >
        <el-form-item
          :label="$t('user.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editAddressObj.name" />
        </el-form-item>
        <el-form-item
          :label="$t('user.phone')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.phone')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editAddressObj.phone" />
        </el-form-item>
        <el-form-item
          :label="$t('tenant.country')"
          :prop="'country'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="editAddressObj.country"
            filterable
            clearable
          >
            <el-option
              v-for="country in countries"
              :key="country"
              :label="$t('countries.' + country)"
              :value="country"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('tenant.province')" :prop="'province'">
          <el-input size="small" v-model.trim="editAddressObj.province" />
        </el-form-item>
        <el-form-item :label="$t('tenant.city')" :prop="'city'">
          <el-input size="small" v-model.trim="editAddressObj.city" />
        </el-form-item>
        <el-form-item :label="$t('tenant.address')" :prop="'address'">
          <el-input size="small" v-model.trim="editAddressObj.address" />
        </el-form-item>
        <el-form-item :label="$t('customer.zipcode')" :prop="'zipcode'">
          <el-input
            size="small"
            v-model.trim="editAddressObj.zipcode"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editAddressDoing"
          size="small"
          @click="editAddressSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editAddressDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import { countries, customerTypes } from "@/utils/enums.js";
import Util from "@/utils/index.js";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";
import Customer from "@/api/customer.js";
import User from "@/api/user.js";
import PayMethod from "@/api/payMethod.js";
import CustomerAddress from "@/api/customerAddress.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    Dropzone,
  },
  data() {
    var validateSerialNoEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("customer.serialNo")]))
        );
        return;
      }
      Customer.findByPhoneOrSerialNo({ keyword: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.editObj.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("customer.serialNo")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    var validatePhone = (rule, value, callback) => {
      const self = this;
      self.phoneRegisteredDF = false;
      if (value === null || value.trim() === "") {
        callback(new Error(this.$t("rules.required", [this.$t("user.phone")])));
        return;
      }
      if (!Util.regexPhone(value)) {
        callback(new Error(self.$t("rules.regex", [self.$t("user.phone")])));
        return;
      }
      Customer.findByPhoneOrSerialNo({ keyword: value.trim() }).then(function (
        res
      ) {
        if (res.data.code === 200 && res.data.entity.id !== self.customer.id) {
          callback(new Error(self.$t("rules.exist", [self.$t("user.phone")])));
        } else {
          callback();
        }
      });
    };
    return {
      customer: { serialNo: null },
      // 分配拥有人
      distributiveOwnerDF: false,
      distributiveOwnerObj: {
        ownerId: null,
      },
      users: [],
      distributiveOwnerDoing: false,
      // 充值
      rechargeDF: false,
      payMethods: [],
      rechargeObj: {
        balance: null,
        payMethodId: null,
        payMethodName: null,
        remark: null,
        voucher: null,
      },
      rechargeDoing: false,
      // 充值积分
      rechargeScoreDF: false,
      rechargeScoreObj: {
        type: "in",
        score: null,
        remark: null,
      },
      rechargeScoreDoing: false,
      // 编辑
      validateSerialNoEdit: validateSerialNoEdit,
      countries: countries,
      customerTypes: customerTypes,
      row: null,
      rowIndex: null,
      editDF: false,
      editObj: {
        serialNo: null,
        phone: null,
        name: null,
        country: null,
        province: null,
        city: null,
        address: null,
        zipcode: null,
        source: null,
        remark: null,
        type: "retail",
        settleType: null,
        email: null,
        sourceTenantId: null,
      },
      editDoing: false,
      //转会员
      validatePhone: validatePhone,
      upgradeToMemberDF: false,
      upgradeToMemberObj: {
        phone: null,
      },
      upgradeToMemberSubmitDoing: false,
      // 新增地址
      addAddressDF: false,
      addAddressObj: {
        customerId: null,
        name: null,
        phone: null,
        country: null,
        province: null,
        city: null,
        address: null,
        zipcode: null,
      },
      addAddressDoing: false,
      // 编辑地址
      editAddressDF: false,
      editAddressObj: {
        name: null,
        phone: null,
        country: null,
        province: null,
        city: null,
        address: null,
        zipcode: null,
      },
      editAddressDoing: false,
    };
  },
  created() {
    const self = this;
    self.getCustomer();
  },
  methods: {
    getCustomer() {
      const self = this;
      self.loadingStart();
      Customer.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.customer = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },

    // 删除
    deleteAddress(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        CustomerAddress.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getCustomer();
          } else {
            self.sysError();
          }
        });
      }
    },
    editAddress(row) {
      const self = this;
      self.row = row;
      self.editAddressObj.name = row.name;
      self.editAddressObj.phone = row.phone;
      self.editAddressObj.country = row.country;
      self.editAddressObj.province = row.province;
      self.editAddressObj.city = row.city;
      self.editAddressObj.address = row.address;
      self.editAddressObj.zipcode = row.zipcode;
      self.editAddressDoing = false;
      self.editAddressDF = true;
    },
    editAddressSubmit() {
      const self = this;
      self.$refs.editAddressObjForm.validate((valid) => {
        if (valid) {
          self.editAddressDoing = true;
          CustomerAddress.update(self.row.id, self.editAddressObj).then(
            function (res) {
              self.editAddressDoing = false;
              self.editAddressDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editAddressSuccess"),
                  type: "success",
                });
                self.getCustomer();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    //
    addAddress() {
      const self = this;
      self.addAddressObj.customerId = self.id;
      self.addAddressObj.name = null;
      self.addAddressObj.phone = null;
      self.addAddressObj.country = null;
      self.addAddressObj.province = null;
      self.addAddressObj.city = null;
      self.addAddressObj.address = null;
      self.addAddressObj.zipcode = null;
      self.addAddressDoing = false;
      self.addAddressDF = true;
    },
    addAddressSubmit() {
      const self = this;
      self.$refs.addAddressObjForm.validate((valid) => {
        if (valid) {
          self.addAddressDoing = true;
          CustomerAddress.create(self.addAddressObj).then(function (res) {
            self.addAddressDoing = false;
            self.addAddressDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addAddressSuccess"),
                type: "success",
              });
              self.getCustomer();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 转会员
    upgradeToMember() {
      const self = this;
      self.upgradeToMemberObj.phone = self.customer.phone;
      self.upgradeToMemberSubmitDoing = false;
      self.upgradeToMemberDF = true;
    },
    upgradeToMemberSubmit() {
      const self = this;
      self.$refs.upgradeToMemberObjForm.validate((valid) => {
        if (valid) {
          self.upgradeToMemberSubmitDoing = true;
          Customer.upgradeToMember(self.id, self.upgradeToMemberObj).then(
            function (res) {
              self.upgradeToMemberSubmitDoing = false;
              self.upgradeToMemberDF = false;
              if (res.status === 200) {
                self.sysResult(
                  res.data,
                  self.$t("prompt.upgradeToMemberSuccess")
                );
                self.getCustomer();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    // 充值
    recharge() {
      const self = this;
      self.rechargeObj.balance = null;
      self.rechargeObj.payMethodId = null;
      self.rechargeObj.payMethodName = null;
      self.rechargeObj.remark = null;
      self.rechargeObj.voucher = null;
      self.rechargeDoing = false;
      PayMethod.findByTypes({ types: PayMethod.balanceTypes }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.payMethods = res.data;
          self.rechargeDF = true;
        } else {
          self.sysError();
        }
      });
    },
    rechargeSubmit() {
      const self = this;
      this.$refs.rechargeObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexPrice(Math.abs(self.rechargeObj.balance))) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("customer.rechargeAmount"),
              ]),
              type: "warning",
            });
            return;
          }
          self.rechargeObj.payMethodName = self.payMethods.find(
            (p) => p.id === self.rechargeObj.payMethodId
          ).name;
          self.rechargeDoing = true;
          Customer.recharge(self.customer.id, self.rechargeObj).then(function (
            res
          ) {
            self.rechargeDoing = false;
            self.rechargeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.rechargeSuccess"),
                type: "success",
              });
              // self.customer.balance =
              //   self.customer.balance + Number(self.rechargeObj.balance);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 充值积分
    rechargeScore() {
      const self = this;
      self.rechargeScoreObj.type = "in";

      self.rechargeScoreObj.score = null;
      self.rechargeScoreObj.remark = null;
      self.rechargeScoreDoing = false;
      self.rechargeScoreDF = true;
    },
    rechargeScoreSubmit() {
      const self = this;
      this.$refs.rechargeScoreObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexNumber(self.rechargeScoreObj.score)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("product.score")]),
              type: "warning",
            });
            return;
          }

          self.rechargeScoreDoing = true;
          Customer.rechargeScore(self.customer.id, self.rechargeScoreObj).then(
            function (res) {
              self.rechargeScoreDoing = false;
              self.rechargeScoreDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.rechargeScoreSuccess"),
                  type: "success",
                });
                if (self.rechargeScoreObj.type == "in") {
                  self.customer.score =
                    self.customer.score + Number(self.rechargeScoreObj.score);
                } else {
                  self.customer.score =
                    self.customer.score - Number(self.rechargeScoreObj.score);
                }
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    // 分配拥有人
    distributiveOwner() {
      const self = this;
      self.distributiveOwnerDoing = false;
      User.findByTenantId(self.Permit.currentTenant().id).then(function (res) {
        if (res.status === 200) {
          self.users = res.data.filter(
            (u) => u.authorize === true && u.voidAt == null
          );
          if (self.users.find((u) => u.id === self.customer.ownerId) != null) {
            self.distributiveOwnerObj.ownerId = self.customer.ownerId;
          }
          self.distributiveOwnerDF = true;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    distributiveOwnerSubmit() {
      const self = this;
      this.$refs.distributiveOwnerObjForm.validate((valid) => {
        if (valid) {
          self.distributiveOwnerDoing = true;
          Customer.distributeOwner(
            self.customer.id,
            self.distributiveOwnerObj
          ).then(function (res) {
            self.distributiveOwnerDoing = false;
            self.distributiveOwnerDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.distributiveSuccess"),
                type: "success",
              });
              self.customer.ownerName = self.users.find(
                (u) => u.id === self.distributiveOwnerObj.ownerId
              ).name;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>